import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { FilteredState, PaginationParams, SortParams, FilterParams } from '../types';
export interface ImportFile {
  id: number;
  file_name: string;
  import_type: string;
  status: string;
  file_size: number;
  uploaded_by: string | null;
  uploaded_at: string;
  progress: number;
  total_rows: number;
  processed_rows: number;
  successful_rows: number;
  failed_rows: number;
  error_message: string | null;
  is_active: boolean;
  created_at: string;
  created_by: string | null;
  updated_at: string | null;
  updated_by: string | null;
}
interface ImportsState extends FilteredState<ImportFile> {
  selectedImport: ImportFile | null;
  uploading: boolean;
  processing: boolean;
}
const initialState: ImportsState = {
  items: [],
  totalCount: 0,
  currentPage: 1,
  pageSize: 25,
  loading: false,
  error: null,
  lastFetch: null,
  filters: {},
  sortField: 'uploaded_at',
  sortDirection: 'desc',
  searchTerm: null,
  selectedImport: null,
  uploading: false,
  processing: false,
};
export const fetchImports = createAsyncThunk(
  'imports/fetchImports',
  async (params: any): Promise<{ data: ImportFile[]; totalCount: number }> => {
    throw new Error('Not implemented yet');
  }
);
export const uploadImportFile = createAsyncThunk(
  'imports/uploadFile',
  async (file: File): Promise<ImportFile> => {
    throw new Error('Not implemented yet');
  }
);
export const processImport = createAsyncThunk(
  'imports/processImport',
  async (id: number): Promise<ImportFile> => {
    throw new Error('Not implemented yet');
  }
);
const importsSlice = createSlice({
  name: 'imports',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<FilterParams>) => {
      state.filters = { ...state.filters, ...action.payload };
      state.currentPage = 1;
    },
    clearFilters: (state) => {
      state.filters = {};
      state.searchTerm = null;
      state.currentPage = 1;
    },
    setSearchTerm: (state, action: PayloadAction<string | null>) => {
      state.searchTerm = action.payload;
      state.currentPage = 1;
    },
    setSort: (state, action: PayloadAction<SortParams>) => {
      state.sortField = action.payload.field;
      state.sortDirection = action.payload.direction;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
      state.currentPage = 1;
    },
    selectImport: (state, action: PayloadAction<ImportFile | null>) => {
      state.selectedImport = action.payload;
    },
    clearSelection: (state) => {
      state.selectedImport = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchImports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchImports.fulfilled, (state, action) => {
        state.loading = false;
        // TODO: Implement proper data handling when thunk is implemented
        state.lastFetch = Date.now();
      })
      .addCase(fetchImports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Error al cargar importaciones';
      });
    builder
      .addCase(uploadImportFile.pending, (state) => {
        state.uploading = true;
        state.error = null;
      })
      .addCase(uploadImportFile.fulfilled, (state, action) => {
        state.uploading = false;
        // TODO: Implement proper data handling when thunk is implemented
      })
      .addCase(uploadImportFile.rejected, (state, action) => {
        state.uploading = false;
        state.error = action.error.message || 'Error al subir archivo';
      });
    builder
      .addCase(processImport.pending, (state) => {
        state.processing = true;
        state.error = null;
      })
      .addCase(processImport.fulfilled, (state, action) => {
        state.processing = false;
        // TODO: Implement proper data handling when thunk is implemented
      })
      .addCase(processImport.rejected, (state, action) => {
        state.processing = false;
        state.error = action.error.message || 'Error al procesar importación';
      });
  },
});
export const { setFilters, clearFilters, setSearchTerm, setSort, setPage, setPageSize, selectImport, clearSelection } = importsSlice.actions;
export default importsSlice.reducer;
